import NarAgentGridOrgTabs from "./components/narAgentGridOrgTabs";
import NarAgentGridResultsPanel from "./components/narAgentGridResultsPanel";
import NarAgentGridSearchFilters from "./components/narAgentGridSearchFilters";
import useNarAgentGridLayout from "./hooks/useNarAgentGridLayout";

/**
 * NAR Agent Grid configuration page: org tabs, insurance/J-code search, and results table.
 *
 * Org tabs are loaded from Firestore `client_wise_config/latest` (not hardcoded).
 */
const NarAgentGridLayout = () => {
  const { tableRef, orgTabs, filters, search, results } =
    useNarAgentGridLayout();

  return (
    <div className="nar-agent-grid--main-container flex h-screen max-h-screen flex-col overflow-hidden">
      <div className="nar-agent-grid__header mb-2 flex items-end justify-between text-h11 font-bold text-primaryGray-1">
        NAR Agent Grid
      </div>

      <NarAgentGridOrgTabs
        tabs={orgTabs.tabs}
        loading={orgTabs.loading}
        activeTab={orgTabs.activeTab}
        onTabChange={orgTabs.setActiveTab}
      />

      <div className="nar-agent-grid__content flex w-full flex-1 flex-col overflow-hidden">
        <div className="nar-agent-grid__table-container flex flex-1 flex-col overflow-hidden px-4 pb-4">
          <NarAgentGridSearchFilters
            activeTab={filters.activeTab}
            insuranceOptions={filters.insuranceOptions}
            selectedInsurance={filters.selectedInsurance}
            onInsuranceChange={filters.setSelectedInsurance}
            selectedJCodes={filters.selectedJCodes}
            onJCodesChange={filters.setSelectedJCodes}
            jCodeOptions={filters.jCodeOptions}
            isLoadingJCodes={filters.isLoadingJCodes}
            isSearchDisabled={search.isSearchDisabled}
            onSearch={() => search.fetchAuthGrid()}
          />
          <NarAgentGridResultsPanel
            tableRef={tableRef}
            isLoading={search.isLoadingAuthGrid}
            apiData={results.apiData}
            clientId={results.clientId}
            onRefetch={search.fetchAuthGridSilent}
          />
        </div>
      </div>
    </div>
  );
};

export default NarAgentGridLayout;
